import { PROJECT_ID } from "config/keys/user";
import { getApp } from "firebase/app";
import { getFirestore, collection } from "firebase/firestore";

const app = getApp(PROJECT_ID);
// =============================== BASE  ===============================  //

export const REF = {
  NAME: "(default)",
  COLLECTIONS: {
    USER: "user",
    MANAGER: "manager",
    SUPPORTER: "supporter",
  },
};

export const getRefs = () => {
  const firestore = getFirestore(app, REF.NAME);
  const CREF = {
    user: collection(firestore, REF.COLLECTIONS.USER),
    manager: collection(firestore, REF.COLLECTIONS.MANAGER),
    supporter: collection(firestore, REF.COLLECTIONS.SUPPORTER),
  };
  return CREF;
};
